import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = ["onClick", "disabled"]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VotingStars',
  props: {
    color: { default: "text-warning" },
    size: { default: "" },
    loop: { default: 5 },
    value: { default: 0 },
    disabled: { type: Boolean, default: false }
  },
  emits: ["onClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const rating = ref(props.value);

const isSolid = (index: number): string =>
  rating.value >= index ? props.color : "text-primary25";

const handlePress = (index: number): void => {
  if (props.disabled) return;
  rating.value = rating.value === index + 1 ? index : index + 1;
  emit("onClick", rating.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loop, (index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        onClick: ($event: any) => (handlePress(index - 1)),
        disabled: _ctx.disabled,
        class: _normalizeClass(["me-1", { 'cursor-pointer': !_ctx.disabled }])
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fas fa-star", [isSolid(index), _ctx.size]])
        }, null, 2)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})